module.exports = __webpack_public_path__ + "static/media/stem-small.5ede2f59.mp4";